import { reportUncaughtException } from 'src/dataLayer/remoteData/rollbar/index.ts';

window.addEventListener('warn', reportUncaughtException);

